export function isDiscordFrame(): boolean {
  try {
    if (window.location.hostname.endsWith("discordsays.com")) return true;
    const inIframe = window.self !== window.top;
    if (!inIframe) return false;
    const q = new URLSearchParams(window.location.search);
    return q.has("frame_id") || q.has("frameId") || q.has("instance_id") || q.has("channel_id") || q.has("channelId");
  } catch {
    return false;
  }
}

export function isAppChannelFrame(): boolean {
  return isDiscordFrame();
}

export function isLocalHost(host: string): boolean {
  return host === "localhost" || host === "127.0.0.1";
}
